import React from "react";
import { X } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import GuideContent, { guideRoleFor } from "./GuideContent";

/**
 * Dashboard user-guide shown as a modal (not a separate page), scoped to the
 * current user's role only. Opened from the DashboardLayout sidebar.
 */
export default function GuideModal({ open, onClose }) {
  const { user } = useAuth();
  if (!open) return null;
  const role = guideRoleFor(user);

  return (
    <div
      className="fixed inset-0 z-50 flex items-start justify-center bg-worker/50 p-4 overflow-y-auto"
      role="dialog"
      aria-modal="true"
      data-testid="guide-modal"
      onClick={onClose}
    >
      <div
        className="bg-cream rounded-md shadow-deep max-w-3xl w-full my-8 p-6 relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-1 rounded-sm hover:bg-sand"
          aria-label="Close"
          data-testid="guide-modal-close"
        >
          <X size={20} className="text-worker" />
        </button>
        <GuideContent role={role} />
      </div>
    </div>
  );
}
